import React from "react"
import { ThemeProvider } from "@emotion/react"
import { theme } from "./theme"
import { HomePage } from "./pages/home/HomePage"
import { LandingPage } from "./pages/landing/LandingPage"
import { useSearchParams } from "./hooks/useSearchParams"

function SubRouter() {
  const queryParams = useSearchParams();
  if ("pwa" in queryParams) {
    return <HomePage />;
  }
  return <LandingPage />;
}

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <SubRouter />
    </ThemeProvider>
  )
}
